import { MapMode } from './../../services/map/map-state.service';
import * as L from 'leaflet';
import { ILatLng } from 'polydraw';
import { environment } from 'src/environments/environment';
import { AreaType } from 'src/models/area-builder/area-type.enum';
import { Area } from 'src/models/area-builder/area.model';
import { IAreaSearchResultDto } from 'src/models/search/area-search-result.model';

export const getAreaTypeNamePlural = (areaTypeId: number): string => {
    switch (areaTypeId) {
        case 5:
            return 'Poststeder';
        case 6:
            return 'Grunnkretser';
        case 7:
            return 'Kommuner';
        case 8:
            return 'Fylker';
        case 9:
            return 'Delbydeler';
        case 10:
            return 'Kommunedeler';
        case 11:
            return 'Bydeler';
        default:
            return areaTypeId.toString();
    }
};
export const getAreaTypeNameSingular = (areaTypeId: number): string => {
    switch (areaTypeId) {
        case 5:
            return 'Poststed';
        case 6:
            return 'Grunnkrets';
        case 7:
            return 'Kommune';
        case 8:
            return 'Fylke';
        case 9:
            return 'Delbydel';
        case 10:
            return 'Kommunedel';
        case 11:
            return 'Bydel';
        default:
            return areaTypeId.toString();
    }
};

export const getWeb40ReturnUrl = (params: URLSearchParams): string => {
  const mapMode = params.get('mapmode');
  if (mapMode === MapMode.Properties.toString()) return `${environment.evwebUrl}/search/estates`;
  if (mapMode === MapMode.NewDwellings.toString()) return `${environment.evwebUrl}/search/projects`;
  //Default to market
  return `${environment.evwebUrl}/search/market`;
};

export const getWeb40QueryParams = (params: URLSearchParams, includePoly = false): string => {
    const lat = params.get('lat');
    const lon = params.get('lon');
    const zoom = params.get('zoom');
    const poly = params.get('poly');
    const favorite = params.get('favoritelist');

    let queryParams = '?areabuilderid=-1';
    if (lat || lon || zoom) {
        queryParams += `&lat=${lat}&lon=${lon}&zoom=${zoom}`;
    }
    if (favorite) {
        queryParams += `&favoritelist=${favorite}`;
    }
    if (includePoly && poly) {
        queryParams += `&poly=${poly}`;
    }
    return queryParams;
};

export const getParentAreaKey = (areaId: number, areaType: AreaType): string =>
    `${areaId}_${areaType}`;

export const getParentAreaIdFromKey = (parentAreaKey: string): number => Number(parentAreaKey.split('_')[0]);
export const getParentAreaTypeFromKey = (parentAreaKey: string): number => Number(parentAreaKey.split('_')[1]);

export const getDisplayName = (area: Area): string => {
    if (area.displayName !== undefined) return area.displayName;

    if (area.areaType === AreaType.PostcodeArea) {
        return padPostnumber(area.number) + ' ' + area.name;
    }
    return area.name;
    function padPostnumber(postnumber: number): string {
        let postcode = '0000' + postnumber;
        return postcode.substring(postcode.length - 4, postcode.length);
    }
};
export const getPostNumberWithFourDigits = (postNumber: number): string => {
    return postNumber.toString().padStart(4, '0');
};

export const createAreaFromSearchResult = (searchResult: IAreaSearchResultDto): Area => {
    let name = searchResult.areaName;
    let number = searchResult.areaId;
    if (searchResult.areaType === 'Poststed') {
      const split = searchResult.areaName.split(' ');
      number = Number(split[0]);
      name = split[1];
    }
    return {
        displayName: searchResult.areaName,
        areaType: searchResult.areaTypeId,
        areaId: searchResult.areaId,
        name: name,
        number: number,
        areas: null,
        areaTypeName: getAreaTypeNameSingular(searchResult.areaTypeId),
        uniqueId: searchResult.areaId + '-' + searchResult.areaTypeId,
    };
}

// Convert ILatLng to L.LatLng
function convertToLeafletLatLng(latlng: ILatLng): L.LatLng {
    return L.latLng(latlng.lat, latlng.lng);
}

// Convert ILatLng[][][] to L.LatLng[][][]
export const convertToLeafletLatLngArray3D = (array3D: ILatLng[][][]): L.LatLng[][][] => {
    return array3D.map(array2D =>
        array2D.map(array1D =>
            array1D.map(latlng =>
                convertToLeafletLatLng(latlng)
            )
        )
    );
}
